import { IUrlWithQuery, parseUrl, stringifyUrl } from './queryString/queryString';
import { TMapBounds } from '../../Map/types/mapBounds';

export class UrlWithBoundsBuilder {
  private readonly parsedUrl: IUrlWithQuery;
  private readonly mapBounds: TMapBounds;

  public constructor(sourceUrl: string, mapBounds: TMapBounds) {
    this.parsedUrl = parseUrl(sourceUrl);
    this.mapBounds = mapBounds;
  }

  public withCenter() {
    if (this.mapBounds.center) {
      this.parsedUrl.query['center'] = this.mapBounds.center.join(',');
    }

    return this;
  }

  public withZoom() {
    if (this.mapBounds.zoom) {
      this.parsedUrl.query['zoom'] = this.mapBounds.zoom;
    }

    return this;
  }

  public withBbox() {
    if (this.mapBounds.bounds) {
      const [[latMin, lngMin], [latMax, lngMax]] = this.mapBounds.bounds;
      this.parsedUrl.query['bbox'] = `${latMin},${lngMin},${latMax},${lngMax}`;
    }

    return this;
  }

  public build() {
    return stringifyUrl(this.parsedUrl);
  }
}
